export default __webpack_public_path__ + "GT-Alpina-Fine-Standard-Bold-Italic.woff2";